/**
 * @author       yontaek@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  FeaturedArticle container
 */

import { selectIsMobile, selectNow } from '@zcode-ui/web-zumper-global-state'
import { PAGE_NAMES } from '@zcode/mixpanel'
import { trackSearchBarClick } from '@zcode/nr/es/shared/components/Autocomplete/trackSearchBarClick'
import type { Dispatch, State } from '@zcode/state-type'
import { connect } from 'react-redux'
import { Header, type HeaderProps } from './Header'

export const mapStateToProps = (state: State) => {
  return {
    isMobile: selectIsMobile(state),
    now: selectNow(state),
  } satisfies Partial<HeaderProps>
}

export const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onClickSearchForm: () => {
      dispatch(trackSearchBarClick({ pageName: PAGE_NAMES.HOMEPAGE }))
    },
  } satisfies Partial<HeaderProps>
}

export const HeaderContainer = connect(mapStateToProps, mapDispatchToProps)(Header)
